var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AAffix',{attrs:{"offsetBottom":_vm.offsetBottom,"offsetTop":_vm.offsetTop,"target":_vm.getContainer},on:{"change":_vm.change}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }